// Height of the navigation tab bar in pixels
export const NAVIGATION_TAB_BAR_HEIGHT = 56;
